// extracted by mini-css-extract-plugin
module.exports = {"fetchObserverWrapper":"InfiniteListPage_fetchObserverWrapper__PFjK9"};